import React from "react";
import "./styles.css"

export const IntakeViewButton = ({...props}) => (
    <div className="view-intake-information" onClick={props.toggleFlyout}>{props.intl.formatMessage({ id: "view_intake_information" })}</div>
)

